const ALLOWED_HOSTS = [
  { host: 'huggingface.co', use: 'On-device LLM model weights (one-time download).' },
  { host: 'api.crossref.org', use: 'DOI resolution and retraction signals for the reference audit.' },
  { host: 'api.openalex.org', use: 'Reviewer-candidate search by topic keywords.' },
  { host: 'eutils.ncbi.nlm.nih.gov', use: 'PubMed reviewer-candidate search.' },
  {
    host: 'generativelanguage.googleapis.com',
    use: 'Opt-in only, OFF by default: Google Gemini, used only if you switch the LLM engine to cloud and add your own key. Manuscript excerpts are sent to Google in that mode.',
  },
];

interface Props {
  compact?: boolean;
}

export function PrivacyInfo({ compact }: Props) {
  return (
    <div>
      <p className="text-xs text-slate-700">
        ManuscriptSkim runs entirely in your browser. The manuscript text and your edits never
        leave this device. The extension only ever contacts these hosts:
      </p>
      <ul className="mt-2 space-y-1">
        {ALLOWED_HOSTS.map((h) => (
          <li key={h.host} className="rounded border border-slate-200 px-2 py-1 text-[11px]">
            <span className="font-mono text-slate-800">{h.host}</span>
            <span className="ml-2 text-slate-500">— {h.use}</span>
          </li>
        ))}
      </ul>
      {!compact && (
        <>
          <p className="mt-2 text-xs text-slate-700">
            <span className="font-medium">To verify:</span> open Chrome DevTools (press
            <kbd className="mx-1 rounded border border-slate-300 px-1 text-[10px]">F12</kbd>
            or right-click → Inspect), switch to the <span className="font-medium">Network</span>
            tab, and use the extension. You should see requests only to the hosts above.
          </p>
          <p className="mt-2 text-[10px] text-slate-500">
            Enforced by a build-time scanner that fails CI if the source ever references an
            unlisted host (ADR-0004).
          </p>
        </>
      )}
    </div>
  );
}
